export const categories = [
  { id: "workplace", name: "职场爆料", desc: "办公桌背后的真实规则", icon: "ri-briefcase-4-line", count: 2418 },
  { id: "industry", name: "行业内幕", desc: "价格与话术之间的事", icon: "ri-store-3-line", count: 1876 },
  { id: "campus", name: "校园见闻", desc: "教室、宿舍与食堂", icon: "ri-graduation-cap-line", count: 1503 },
  { id: "city", name: "城市现场", desc: "街头巷尾的第一现场", icon: "ri-building-2-line", count: 2694 },
  { id: "emotion", name: "情感故事", desc: "关系里的观察记录", icon: "ri-heart-3-line", count: 2151 },
  { id: "life", name: "生活观察", desc: "日常细节里的另一面", icon: "ri-cup-line", count: 2204 },
];

export const works = [
  {
    id: "overtime-ledger",
    title: "我把三年的加班记录整理成了一张表",
    category: "workplace",
    categoryName: "职场爆料",
    author: "夜班小周",
    authorNote: "连续三年准时打卡下班失败者",
    date: "2026-09-06",
    readTime: "8 分钟",
    likes: 4821,
    views: 128940,
    comments: 386,
    hot: true,
    tags: ["加班", "工时", "办公室日常", "记录"],
    summary:
      "三年，1095 天，我把每一次被临时叫回工位的时刻都记在了手机备忘录里。整理成表格的那天我才发现，真正被占走的不是时间，而是那些本来属于自己的晚上。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20worn%20paper%20ledger%20with%20handwritten%20tables%20beside%20a%20desk%20lamp%20and%20cold%20coffee%20cup%2C%20warm%20amber%20and%20deep%20vermillion%20tones%2C%20soft%20natural%20window%20light%2C%20quiet%20melancholic%20mood%2C%20high%20detail%20documentary%20still%20life&width=800&height=500&seq=bl-work-overtime-01&orientation=landscape",
    content: [
      "备忘录里最早的一条记录，是三年前的一个周三晚上。那天我在 21 点 40 分被叫回工位，理由只有四个字：「线上看一下」。我在楼下便利店买了瓶水，又走了回去。",
      "后来我养成了一个习惯：只要被临时叫回，就在备忘录里记一行——日期、时间、谁叫的、什么事、持续多久。三年下来，一共 187 行。",
      "把 187 行整理成表格之后，我按月份做了统计。数字最扎眼的是去年 11 月：那个月里，我有 14 个晚上被叫回过公司或者在线处理事情，平均每次 1 小时 42 分钟。",
      "我不是想控诉谁。事实上，我的同事大多也和善，团队也没有恶意。真正让我想把这些写下来的，是我发现「临时」这两个字被用得越来越顺手了。",
      "当一件本该提前安排的事情变成「临时」，说话的人省下了计划成本，而接住它的人付出的是整段被打断的私人时间。这个成本一直没有被认真计算过。",
      "所以我把这张表公开了。它不代表任何一家公司，只代表一个普通打工人三年里真实的晚上。如果你也有类似的记录，或许可以试着整理一次——数字会比情绪更早说明问题。",
    ],
  },
  {
    id: "supplier-price",
    title: "供应商报价单上的第三列，藏着什么",
    category: "industry",
    categoryName: "行业内幕",
    author: "老陈看货",
    authorNote: "在批发市场待了十一年",
    date: "2026-09-04",
    readTime: "7 分钟",
    likes: 3960,
    views: 96430,
    comments: 241,
    hot: true,
    tags: ["报价", "批发", "采购", "行业内幕"],
    summary:
      "同一款货，同一张报价单，不同的客户看到的是不同的数字。第三列从来不会主动展示，但它决定了你最终付多少钱。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20stacked%20printed%20quotation%20sheets%20with%20columns%20of%20numbers%20on%20a%20wooden%20counter%20in%20a%20wholesale%20market%2C%20warm%20amber%20lighting%20with%20red%20accent%20details%2C%20shallow%20depth%20of%20field%2C%20documentary%20editorial%20photography&width=800&height=500&seq=bl-work-supplier-02&orientation=landscape",
    content: [
      "批发市场里流传一句话：「报价单不是给你看的，是给你签的。」刚入行的时候我不信，后来我信了。",
      "一张标准的报价单通常有三列：货号、数量区间、单价。但真正在用的版本会有第三点五列，写在最右边，用很小的字号，写着「档位」。",
      "档位是什么意思？简单说，同一批货，报给不同客户的价格不一样。老客户、新客户、一次性采购、长期走量，对应不同的档位。这本身不算违规，做生意本来就有弹性。",
      "问题出在档位不透明。采购方拿着报价单以为看到的是全部信息，实际上看到的只是给自己那一档的数字。",
      "我见过不少小店主因为不知道这一点，在同一批货上多付了两到三成的钱，还以为自己谈得不错。",
      "写这篇不是让人去砍价，而是想说明一件事：任何一张只给你看两列的报价单，都值得多问一句——「还有别的档位吗？」问出来的答案，往往比价格本身更有价值。",
    ],
  },
  {
    id: "dorm-night",
    title: "宿舍深夜录音：熄灯后的第二场会议",
    category: "campus",
    categoryName: "校园见闻",
    author: "四号楼 409",
    authorNote: "大四，即将毕业",
    date: "2026-09-02",
    readTime: "6 分钟",
    likes: 3120,
    views: 78210,
    comments: 198,
    hot: true,
    tags: ["宿舍", "校园生活", "深夜", "观察"],
    summary:
      "熄灯之后，宿舍才真正开始开会。聊的内容和白天课堂上完全不一样，而且几乎没有人承认自己说过。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20dark%20university%20dormitory%20room%20at%20night%20with%20warm%20bedside%20lamp%20glow%2C%20bunk%20beds%20and%20books%2C%20amber%20and%20deep%20red%20color%20palette%2C%20cinematic%20editorial%20mood%2C%20soft%20shadows%2C%20intimate%20documentary%20style&width=800&height=500&seq=bl-work-dorm-03&orientation=landscape",
    content: [
      "我们宿舍有一个不成文的规矩：11 点熄灯，熄灯之后不睡。",
      "白天的我们各自去上各自的课，回宿舍也只是打招呼、拿东西、点外卖。真正把四个人凑在一起的，是熄灯之后那半小时。",
      "那半个小时的谈话内容，说出来可能没什么特别：吐槽某门课的作业量，讨论要不要考研，聊家里的事，偶尔也聊以后想去哪个城市。",
      "但奇怪的是，这些内容在白天几乎从不出现。仿佛白天有一个隐形的审核机制，把「认真的话」都过滤掉了。",
      "我想了很久，大概是因为熄灯之后看不见彼此的脸。黑暗让人可以只说内容，不用同时管理表情。",
      "四年下来，我录下了很多个夜晚（征得了舍友同意）。回听的时候最打动我的不是哪句话多深刻，而是我们居然有那么多话，只在黑暗里才说得出口。",
    ],
  },
  {
    id: "rent-receipt",
    title: "房东的收据本，写满了同一间房的十个价格",
    category: "city",
    categoryName: "城市现场",
    author: "租客阿May",
    authorNote: "第七次搬家之后决定停下来看看",
    date: "2026-08-29",
    readTime: "9 分钟",
    likes: 5210,
    views: 154320,
    comments: 512,
    hot: true,
    tags: ["租房", "城市", "收据", "记录"],
    summary:
      "搬走那天，我在房东抽屉里看到一本旧收据。同一间 38 平的房子，五年里出现过十个不同的月租数字。",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20stack%20of%20rent%20receipt%20books%20with%20handwritten%20amounts%20on%20a%20small%20apartment%20table%20near%20a%20window%2C%20warm%20late%20afternoon%20sunlight%2C%20vermillion%20and%20cream%20tones%2C%20nostalgic%20editorial%20documentary%20photography%2C%20shallow%20focus&width=800&height=500&seq=bl-work-rent-04&orientation=landscape",
    content: [
      "我在这间 38 平的房子里住了两年零三个月。搬走那天，房东来收钥匙，顺手把抽屉里的一摞旧收据拿了出来准备扔掉。",
      "我问能不能让我看一眼。他愣了一下，说「看吧，都是废纸」。",
      "那本收据记录了很久。从最早的 2400 元，到最新的一页 4100 元，中间出现过好几个数字：2650、2800、3000、3200、3500、3800、3950……同一间房，五个年头，十个价格。",
      "我把它们抄了下来。不是为了指责涨价——城市里的房租会涨，这是客观的。让我在意的是，每个价格背后的租客，可能都以为自己谈到的是「合理价位」。",
      "因为没有人知道自己之前的人付多少，也没有人知道自己之后的人付多少。信息被切成了一段一段，每个人只能看到自己那一段。",
      "我写这篇，是想说一句很朴素的话：在陌生的城市里，我们其实是彼此的参照。如果租房的人愿意多交流一句，很多「说不清」的事情，会变得清楚一点。",
    ],
  },
  {
    id: "blind-date",
    title: "相亲第 37 次，我带着一张观察表去了",
    category: "emotion",
    categoryName: "情感故事",
    author: "一杯温的",
    authorNote: "记录型相亲选手",
    date: "2026-08-26",
    readTime: "7 分钟",
    likes: 2870,
    views: 71230,
    comments: 305,
    hot: false,
    tags: ["相亲", "观察", "关系", "记录"],
    summary:
      "不是不认真，恰恰是因为太认真，我才决定把每一次见面都记录下来——记的不是对方，是我自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20coffee%20cups%20on%20a%20small%20cafe%20table%20from%20above%20with%20a%20notebook%20and%20pen%2C%20warm%20cream%20and%20red%20accent%20palette%2C%20soft%20morning%20light%2C%20calm%20editorial%20still%20life%2C%20cozy%20minimalist%20composition&width=800&height=500&seq=bl-work-date-05&orientation=landscape",
    content: [
      "我相亲的次数不算少，第 37 次之前，我已经记不清前 36 次都聊了什么。",
      "朋友笑我，说相亲还要做笔记是不是太功利。我说恰恰相反，我记的不是对方的信息，是我自己的反应。",
      "表格只有三列：见面时间、我说话的比例、结束后我想不想再见一次。",
      "记到二十多次的时候，一个规律冒了出来：凡是那一次我说话比例超过七成，结束后我的意愿就明显偏低。",
      "一开始我以为是对方的问题，后来才发现是我自己——当我一直说话的时候，往往是因为紧张，用说话填满沉默，反而没有真正在听。",
      "所以第 37 次，我刻意给自己定了一个目标：让对方说话超过一半。那次见完，我在最后一栏写了「想」。",
      "我想说的是，记录确实是一种很笨的方法，但它让一件模糊的事情变得可以被讨论。对于像我这样容易在情绪里打转的人来说，笨方法反而是最有用的。",
    ],
  },
  {
    id: "wet-market",
    title: "凌晨四点的水产市场，我跟着一箱虾走完全程",
    category: "life",
    categoryName: "生活观察",
    author: "起早的人",
    authorNote: "习惯在天亮前出门",
    date: "2026-08-22",
    readTime: "8 分钟",
    likes: 3410,
    views: 88640,
    comments: 176,
    hot: false,
    tags: ["水产", "凌晨", "城市观察", "细节"],
    summary:
      "从卸车到上摊，再到被人买走，一箱虾只用了三个小时。这三个小时里发生的事，比它之后被端上餐桌的过程要复杂得多。",
    cover:
      "https://readdy.ai/api/search-image?query=Pre-dawn%20wholesale%20seafood%20market%20with%20stacked%20crates%20of%20fresh%20shrimp%20under%20warm%20hanging%20lamps%2C%20wet%20concrete%20floor%20reflections%2C%20deep%20red%20and%20amber%20tones%2C%20cinematic%20documentary%20photography%2C%20busy%20textured%20scene&width=800&height=500&seq=bl-work-market-06&orientation=landscape",
    content: [
      "凌晨四点，市场还没有真正热闹起来，但车已经进不去了。我跟着一箱从车上卸下来的虾，从市场东门开始走。",
      "第一站是分拣区。工人戴着头灯，按大小把虾分级，动作快得像在打字。同一批货会被分成三到四个等级，价格相差可以到一倍。",
      "第二站是过秤。这一步我看了很久，因为秤旁边永远站着一个手里拿着小本子的人，他在记的不是重量，是货的去向。",
      "第三站是摊位上架。上架之前会有一道「补水」工序，这一步没有招牌，也没人主动解释，但它直接决定了这箱虾摆出去之后看起来有多精神。",
      "从卸车到上摊，整箱虾走完了三个小时。之后它可能会被餐馆收走，也可能被散客买回家，但那已经是另一段故事了。",
      "我把这三个小时写下来，不是为了揭穿什么，而是想说：我们每天吃到的东西，背后有一整套看不见的流程在支撑，而流程里的每一个环节，都值得被认真看一眼。",
    ],
  },
  {
    id: "recruit-ad",
    title: "招聘启事里那句「抗压能力强」，到底写给谁",
    category: "workplace",
    categoryName: "职场爆料",
    author: "简历改到吐",
    authorNote: "半年投了 220 份简历",
    date: "2026-08-19",
    readTime: "6 分钟",
    likes: 2680,
    views: 64980,
    comments: 214,
    hot: false,
    tags: ["招聘", "职场", "岗位描述", "求职"],
    summary:
      "把 220 份招聘启事放在一起之后，我数了数出现频率最高的词。排第一的，不是任何一项具体技能。",
    cover:
      "https://readdy.ai/api/search-image?query=Desk%20covered%20with%20printed%20job%20postings%20and%20a%20resume%20with%20a%20red%20pen%20beside%20a%20laptop%2C%20warm%20cream%20background%20with%20vermillion%20accents%2C%20natural%20daylight%20from%20a%20side%20window%2C%20clean%20editorial%20flat%20lay%20photography&width=800&height=500&seq=bl-work-recruit-07&orientation=landscape",
    content: [
      "找工作那段时间，我养成了一个习惯：每投一份简历，就把招聘启事复制到文档里。",
      "半年下来，文档里有 220 条记录。我把它们做了一次词频统计。",
      "结果有点出乎意料。出现频率最高的描述，不是任何一项硬技能，而是「抗压能力强」，出现了 141 次，覆盖六成以上的岗位。",
      "紧跟在后面的是「有责任心」「能接受弹性工作」「结果导向」。这些词有一个共同点：它们都在描述一个人对压力的承受方式，而不是他具体会做什么。",
      "我不认为这些要求本身有问题。但如果一份启事把大量篇幅花在这里，却对具体职责语焉不详，那它传递的信息其实是：这个岗位的压力可能不小。",
      "所以现在我筛岗位的方式很简单：先看职责描述是否具体到可以复述，再看要求里有多少是「承受型」的词。这个方法帮我省下过不少无效面试。",
    ],
  },
  {
    id: "second-hand",
    title: "二手平台上的同款包，来自同一间仓库",
    category: "industry",
    categoryName: "行业内幕",
    author: "放大镜",
    authorNote: "习惯看商品背景里的小细节",
    date: "2026-08-15",
    readTime: "7 分钟",
    likes: 4100,
    views: 108760,
    comments: 289,
    hot: true,
    tags: ["二手", "电商", "细节", "观察"],
    summary:
      "我对比了同一个型号的 40 条在售记录。它们号称来自不同城市、不同卖家、不同故事，但背景里那张桌子是同一种。",
    cover:
      "https://readdy.ai/api/search-image?query=Orderly%20warehouse%20shelf%20with%20rows%20of%20identical%20packaged%20boxes%20under%20warm%20industrial%20lamps%2C%20deep%20red%20and%20amber%20tones%2C%20clean%20editorial%20documentary%20photography%2C%20long%20perspective%20view%2C%20soft%20shadows&width=800&height=500&seq=bl-work-warehouse-08&orientation=landscape",
    content: [
      "我本来只是想买一个二手的通勤包。",
      "在对比价格的时候，我发现同一个型号下有几十条在售记录，卖家分散在不同城市，描述也各不相同：有说朋友送的，有说前任留的，有说买错了颜色的。",
      "但它们拍出来的照片，有一些细节对得上：背景里那张浅色木纹桌子的边缘纹路，是同一块；窗台上那盆植物，看着也是同一盆。",
      "我把这些记录的图片截图拼在一起，一共 40 条。根据背景的一致性，我判断其中至少 26 条来自同一个地点。",
      "这不一定是坏事，也可能是同一家二手店的多个账号在铺货。但当「个人闲置」的叙述被统一包装出来时，买家其实失去了一次重要的判断依据。",
      "我把这次整理的思路写下来，没有点名任何卖家。如果你也在二手平台买东西，或许可以多看一眼背景：桌子、光线、墙面，它们往往比描述更诚实。",
    ],
  },
  {
    id: "campus-canteen",
    title: "食堂窗口的菜单，五个月没换过一句话",
    category: "campus",
    categoryName: "校园见闻",
    author: "排队的人",
    authorNote: "在同一个窗口吃了两年",
    date: "2026-08-11",
    readTime: "5 分钟",
    likes: 1980,
    views: 52140,
    comments: 143,
    hot: false,
    tags: ["食堂", "校园", "菜单", "日常"],
    summary:
      "我拍下了同一个窗口的菜单牌，从三月初到七月底。菜名一个字没变，但排在第一位的那道菜，变了四次价格。",
    cover:
      "https://readdy.ai/api/search-image?query=University%20canteen%20counter%20with%20a%20handwritten%20menu%20board%20on%20a%20tiled%20wall%2C%20warm%20amber%20indoor%20lighting%2C%20trays%20and%20serving%20spoons%2C%20red%20accent%20details%2C%20everyday%20documentary%20editorial%20photography&width=800&height=500&seq=bl-work-canteen-09&orientation=landscape",
    content: [
      "我在同一个食堂窗口吃了两年饭，所以我认识那块菜单牌。",
      "从三月初开始，我每个月月底给它拍一张照片，一共拍了五张。",
      "把五张照片并排放在一起，最直观的感觉是「没变」——菜名还是那九道，顺序也没动。",
      "但如果仔细看价格那一栏，变化就出来了：排在第一位的那道菜，价格改过四次，从 12 元一路到 15 元；而排在最后的那道，五个月一分没动。",
      "我猜这大概是成本结构不同导致的，本身可以理解。让我觉得有意思的是，改价的方式很轻——只是把 12 贴掉，写上 15，没有通知，也没有说明。",
      "写这个不是想抱怨食堂。我只是想说，那些每天经过却从不停留的地方，其实一直在悄悄变化。偶尔停下来拍一张照，可能会看到平时忽略的东西。",
    ],
  },
];

export const faqs = [
  {
    q: "爆料大赛是什么？参赛作品都包含哪些类型？",
    a: "爆料大赛是一个面向所有人的公开投稿活动，鼓励参赛者把身边真实、具体、有细节的观察写下来。参赛作品涵盖职场爆料、行业内幕、校园见闻、城市现场、情感故事与生活观察等六大方向，本站作品集收录的就是这些投稿中的精选内容。",
  },
  {
    q: "如何浏览和找到自己想看的参赛作品？",
    a: "你可以直接进入参赛作品集页面，通过关键词搜索定位主题，也可以用顶部的分类标签快速切换方向，还能按「最新投稿」「最多点赞」「最多浏览」排序。每篇作品详情页底部还有相关推荐，方便连续阅读。",
  },
  {
    q: "投稿作品有什么基本要求？",
    a: "作品需要是真实经历的记录，有具体的时间、场景与细节，避免虚构情节和人身攻击。建议正文控制在 800 至 3000 字之间，并为主题选择合适的分类，方便其他读者检索。",
  },
  {
    q: "作品集里的数据（点赞、浏览）是如何统计的？",
    a: "页面展示的点赞、浏览与评论数据用于呈现参赛作品的热度，帮助读者快速了解哪些投稿更受关注。排序功能会依据这些数据实时调整展示顺序。",
  },
  {
    q: "可以同时投稿多篇作品吗？",
    a: "可以。同一位参赛者可以提交多篇不同主题的作品，每篇都会独立进入作品集并单独计分。若多篇作品内容重复度过高，评审会合并展示。",
  },
  {
    q: "投稿之后多久能在作品集里看到？",
    a: "投稿提交后会先经过一次内容审核，主要核对真实性与基本规范，通常在三个工作日内完成。通过审核的作品会出现在参赛作品集中，并进入对应的分类与排行榜。",
  },
];

export const stats = [
  { label: "累计投稿作品", value: "12,846", unit: "篇" },
  { label: "参赛创作者", value: "3,920", unit: "位" },
  { label: "本期精选展出", value: "486", unit: "篇" },
  { label: "读者累计浏览", value: "2.7", unit: "百万" },
];

export const timeline = [
  { phase: "征稿期", date: "即日起 — 10 月 20 日", desc: "开放全品类投稿，作品随到随审，通过后即可进入作品集。" },
  { phase: "展播期", date: "10 月 21 日 — 11 月 05 日", desc: "集中展播精选作品，开放读者点赞与浏览排行。" },
  { phase: "评审期", date: "11 月 06 日 — 11 月 15 日", desc: "评审团依据真实性与细节度对入围作品进行打分。" },
  { phase: "揭晓期", date: "11 月 20 日", desc: "公布本期优秀作品名单，并在作品集首页展示。" },
];

export const testimonials = [
  { name: "夜航船", role: "参赛者 · 职场方向", text: "本来只是随手写了点工作记录，放在作品集里之后收到了很多陌生人的留言，才发现原来大家都在经历类似的事。" },
  { name: "南风知我意", role: "读者 · 连续关注三期", text: "最喜欢这里的分类方式，点进「城市现场」就能一口气看完一整组，比在信息流里刷碎片内容踏实多了。" },
  { name: "老式打字机", role: "参赛者 · 生活观察", text: "评审看重的是细节而不是标题党，这一点我特别认同。写清楚一件小事，比制造情绪更难得。" },
];